import TextField from "@mui/material/TextField";
import MenuItem from "@mui/material/MenuItem";
import NewMachineModal from "./NewMachineModal";
import { useState, useEffect, useId } from "react";
import { axiosInstance, buildLegacyHeaders } from "../../axiosFetchers";
import { useAuth } from "../../../Components/Auth/useAuth";
import { buildSparsePayload } from "../../../utils/sparsePayload";

export default function SelectMachineField({
  fieldLabel,
  machineType,
  fieldState,
  handleMachineChange,
  handleHoursChange,
  farm,
  setFarm,
  validationTargetId = "",
  errorFound = { machineObj: false, hoursUsed: false },
}) {
  const [machinesArray, setMachinesArray] = useState([]);
  const [isTractorModalOpen, setIsTractorModalOpen] = useState(false);
  const { user } = useAuth();
  const machineSelectId = useId();
  const hoursInputId = useId();

  async function handleAddNewMachine(newMachine) {
    const response = await axiosInstance.post(
      process.env.REACT_APP_API_URL + `/machines`,
      buildSparsePayload({
        ...newMachine,
        farm_id: Number(farm?.id),
      }),
      {
        headers: buildLegacyHeaders(user),
      }
    );

    handleMachineChange(response.data.id);
    setFarm?.((prevState) => {
      if (!prevState) {
        return prevState;
      }

      const nextMachines = Array.isArray(prevState.machines)
        ? [...prevState.machines, response.data]
        : [response.data];

      return {
        ...prevState,
        machines: nextMachines,
      };
    });
  }

  useEffect(() => {
    setMachinesArray((farm?.machines || []).filter((m) => m.type === machineType));
  }, [farm, machineType]);

  return (
    <div
      id={validationTargetId || undefined}
      className={`mt-3 flex w-full max-w-[520px] flex-wrap items-start gap-3 rounded-[8px] ${
        errorFound.machineObj || errorFound.hoursUsed
          ? "ring-2 ring-red-200 ring-offset-2"
          : ""
      }`}
    >
      <TextField
        id={machineSelectId}
        select
        error={errorFound.machineObj}
        size="small"
        sx={{ width: "100%", maxWidth: "340px" }}
        value={fieldState.machine_id}
        label={fieldLabel || "Select Equipment"}
        onChange={(e) => handleMachineChange(e.target.value)}
      >
        <MenuItem key={"None"} value={""}>
          <p>None</p>
        </MenuItem>
        {machinesArray.map((tractorOption) => (
          <MenuItem key={tractorOption.id} value={tractorOption.id}>
            <p>{tractorOption.name}</p>
          </MenuItem>
        ))}
        <MenuItem key={"addTractor"} onClick={() => setIsTractorModalOpen(true)}>
          <p>{`Add a New ${
            machineType[0] + machineType.slice(1).toLowerCase()
          }`}</p>
        </MenuItem>
      </TextField>
      <TextField
        id={hoursInputId}
        size="small"
        sx={{ color: "#666666", width: 140 }}
        label={"Hours Used"}
        InputProps={{ inputProps: { min: 0 } }}
        type="number"
        error={errorFound.hoursUsed}
        helperText={
          errorFound.hoursUsed ? "Use zero or a positive number." : ""
        }
        onChange={(e) => handleHoursChange(e.target.value)}
        InputLabelProps={{
          shrink: true,
        }}
        variant="outlined"
        value={fieldState.hours_used}
      />

      {isTractorModalOpen && (
        <NewMachineModal
          open={isTractorModalOpen}
          handleClose={setIsTractorModalOpen}
          machineLabel={fieldLabel}
          machineType={machineType}
          handleAddNewMachine={handleAddNewMachine}
        />
      )}
    </div>
  );
}
